import { Components, Theme } from '@mui/material';
import { wbColors as colors } from '@workbuzz/shared-ui';

export const MuiMenuItemStyles: Components<Omit<Theme, 'components'>> = {
  MuiMenuItem: {
    styleOverrides: {
      root: {
        minWidth: 200,
        '> .MuiLink-root': {
          color: colors.mineShaft,
          textDecoration: 'none',
          whiteSpace: 'normal',
          textAlign: 'right',
          padding: '6px 16px',
        },
        '&:hover': {
          backgroundColor: colors.ashInTheAir,
        },
        '&:focus-visible': {
          background: colors.ashInTheAir,
        },
        '& > .MuiLink-root': {
          '&:hover': {
            backgroundColor: colors.ashInTheAir,
          },
        },
        '&.Mui-selected': {
          background: colors.ghost,
          '&:focus-visible': {
            background: colors.ghost,
          },
          '&:hover': {
            background: colors.ghost,
          },
        },
      },
    },
  },
};
